(function ($) {
  $(document).ready(function () {
    var app = {
      isMobile: false,
      isTablet: false,
      breakPointTablet: 1024,
      breakPointMobile: 640,
      init: function () {
        app.handleResize();
        app.responsiveDetection();
        app.initFoundations();
        app.initSwiperTemoignages();
        app.initSwiperHeros();
        app.initSwiperSolutions();
        app.initSwiperChiffresCles();
        app.initSwiperArticles();
        app.initBlockEtapes();
        app.initSwiperListVehicules();
        app.initSwiperImages2Cols();
        app.navScrollInit();
        app.navAnchorInit();
        app.scrollWindow();
        app.initCustomSelect();
        app.customFormConstatCalcul();
        app.burgerMenu();
        app.flipCardsMobile();
        app.initDataLayerClick();
        app.modalFeatures();
        app.videoModalHandle();
        // app.initDataLayerSubmit();
        $(".header").addClass("loaded");
        $(document).ajaxComplete(function (e, x, s) {
          app.initCustomSelect();
          app.initDataLayerSubmit();
        });
      },
      videoModalHandle() {
        if ($(".block-video").length || $(".block-edito-text-video").length) {
          const closeButton = document.querySelectorAll(".close-button");
          const revealOverlay = document.querySelectorAll(".reveal-overlay");
          const videoFrames = document.querySelectorAll(
            ".reveal .embed-responsive-item",
          );

          function loadVideo() {
            videoFrames.forEach((videoFrame) => {
              videoFrame.src = videoFrame.dataset.src;
            });
          }
          loadVideo();

          [closeButton, revealOverlay].forEach((el) => {
            el.forEach((el) => {
              el.addEventListener("click", () => {
                loadVideo();
              });
            });
          });
        }
      },
      handleResize: function () {
        $(window).on("resize", function () {
          app.responsiveDetection();
          app.initSwiperListVehicules();
          app.burgerMenu();
          app.flipCardsMobile();
        });
      },

      responsiveDetection: function () {
        app.isMobile = $(window).width() < app.breakPointMobile;
        app.isTablet = $(window).width() < app.breakPointTablet;
      },
      initFoundations: function () {
        $(document).foundation();
      },
      initSwiperTemoignages: function () {
        if ($(".swiper-temoignages").length > 0) {
          const swiper = new Swiper(".swiper-temoignages", {
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      },
      initSwiperHeros: function () {
        console.log('initSwiperHeros')
        if ($(".swiper-heros").length > 0) {
          const swiper = new Swiper('.swiper-heros', {
            direction: "horizontal",
            loop: false,
            slidesPerView: 1,
            pagination: {
              el: ".swiper-heros .swiper-pagination",
              clickable: true,
            },
          });
          console.log(swiper);
        }
      },
      initSwiperSolutions: function () {
        if ($(".swiper-solutions").length > 0) {
          const SwiperSolutionsPagination = [];
          let labels = {};
          $(".swiper-solutions")
            .find(".block-solution")
            .each(function () {
              const _title = $(this).attr("data-title-pagination");
              labels = _title;
              SwiperSolutionsPagination.push(labels);
            });

          const SolutionsSwiper = new Swiper(".swiper-solutions", {
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
              el: ".swiper-solutions .swiper-pagination-wrapper .swiper-pagination-text",
              clickable: true,
              renderBullet: function (index, className) {
                return (
                  '<div class="' +
                  className +
                  '"><div class="title">' +
                  SwiperSolutionsPagination[index] +
                  "</div></div>"
                );
              },
            },
          });
        }
      },
      initSwiperChiffresCles: function () {
        if ($(".swiper-chiffres-cles").length > 0) {
          const swiper = new Swiper(".swiper-chiffres-cles", {
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
              delay: 5000,
            },
            navigation: {
              nextEl: ".swiper-button-next-chiffres-cles",
              prevEl: ".swiper-button-prev-chiffres-cles",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            on: {
              init: function () {},
              slideChangeTransitionStart: function () {
                const _allSlides = $(".swiper-chiffres-cles .swiper-slide");
                _allSlides.each(function () {
                  let _wrapperProgressBar = $(this).find(
                    ".block-chiffre-cles .progress-bar-circle svg",
                  );
                  _wrapperProgressBar.remove();
                });
                const _progressBarSlideActive = $(
                  ".swiper-slide.swiper-slide-active .progress-bar-circle",
                )[0];
                $(
                  ".swiper-slide.swiper-slide-active .progress-bar-circle",
                ).each(function () {
                  app.initProgressBar(
                    $(this)[0],
                    $(this).attr("data-percentage"),
                  );
                });
              },
            },
          });
        }
      },
      initProgressBar: function (wrapper, percentage = 1) {
        let bar;
        bar = new ProgressBar.Circle(wrapper, {
          strokeWidth: 6,
          easing: "easeInOut",
          duration: 2500,
          color: "#ffffff",
          trailColor: "rgba(255,255,255,0.14)",
          svgStyle: null,
        });
        bar.animate(percentage, {
          duration: 2500,
        });
      },
      initSwiperArticles: function () {
        if ($(".swiper-articles")) {
          const swiper = new Swiper(".swiper-articles", {
            speed: 400,
            slidesPerView: 3.5,
            spaceBetween: 35,
            grabCursor: true,
            breakpoints: {
              320: {
                slidesPerView: 1.5,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 2.5,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 3.5,
                spaceBetween: 35,
              },
            },
          });
        }
      },
      initBlockEtapes: function () {
        if ($(".block-etapes-list").length > 0) {
          const windowHeight = $(window).height();

          $(window).on("scroll", function () {
            $(".block-etape-item").each(function () {
              let _thisOffset = $(this).offset().top - windowHeight + 170;

              if ($(window).scrollTop() > _thisOffset) {
                $(this).addClass("is-hover");
              } else {
                $(this).removeClass("is-hover");
              }
            });

            if ($(".timeline").length > 0) {
              const timelineHeight = $(".timeline").height();
              const timelineOffset =
                $(".timeline").offset().top - windowHeight + 170;

              if ($(window).scrollTop() > timelineOffset) {
                const scrollHeight = $(window).scrollTop() - timelineOffset;
                const scrollPercentage = scrollHeight / timelineHeight;
                const scrollPercentageRounded = Math.min(
                  Math.round(scrollPercentage * 100),
                  100,
                );
                $(".timeline").css(
                  "--currentProgress",
                  scrollPercentageRounded + "%",
                );
              }
            }
          });
        }
      },
      initSwiperListVehicules: function () {
        if ($(".swiper-list-vehicules")) {
          const breakpoint = window.matchMedia("(min-width: 40em)");
          let mySwiper;

          const breakpointChecker = function () {
            if (breakpoint.matches === true) {
              if (mySwiper !== undefined) mySwiper.destroy(true, true);
              return;
            } else if (breakpoint.matches === false) {
              return enableSwiper();
            }
          };

          const enableSwiper = function () {
            mySwiper = new Swiper(".swiper-list-vehicules", {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 0,
              a11y: true,
              keyboardControl: true,
              grabCursor: true,
            });
          };
          breakpoint.addEventListener("change", breakpointChecker);
          breakpointChecker();
        }
      },
      initSwiperImages2Cols: function () {
        if ($(".swiper-img-2cols")) {
          const swiper = new Swiper(".swiper-img-2cols", {
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
          });
        }
      },
      scrollWindow: function () {
        $(window).on("scroll", function () {
          app.navScrollInit();
          app.stickyHeader();
          app.stickyAnchors();
        });
      },
      navAnchorInit: function () {
        var link = $("#anchor a.dot");
        var labelName = $("p.name");

        link.on("click", function (e) {
          e.preventDefault();

          var target = $($(this).attr("href"));
          $("html, body").animate(
            {
              scrollTop: target.offset().top - 202,
            },
            600,
          );

          //$(this).addClass('active');
          var nameSection = $(this).attr("data-name");
          labelName.html(nameSection);
        });
      },

      // Nav anchor
      navScrollInit: function () {
        var link = $("#anchor a.dot");
        var labelName = $(".name");
        var sTop = $(window).scrollTop();

        if (labelName.text() === "intro") {
          labelName.addClass("white");
        } else {
          labelName.removeClass("white");
        }

        $(".block-section").each(function () {
          var id = $(this).attr("id"),
            name = $(this).attr("name"),
            offset = $(this).offset().top - 202,
            height = $(this).height();

          if (sTop >= offset && sTop < offset + height) {
            link.removeClass("active");
            $("#anchor")
              .find('[data-scroll="' + id + '"]')
              .addClass("active");
            labelName.html(name);
          }
        });
      },
      stickyHeader: function () {
        if ($(".header").length > 0) {
          if ($(window).scrollTop() >= 120) {
            $(".header").addClass("fixed-header");
          } else {
            $(".header").removeClass("fixed-header");
          }
        }
      },
      stickyAnchors: function () {
        if ($(".anchor").length > 0) {
          if ($(window).scrollTop() >= 470) {
            $(".anchor").addClass("fixed-sub-header");
          } else {
            $(".anchor").removeClass("fixed-sub-header");
          }
        }
      },
      initCustomSelect: function () {
        if ($(".custom-form").length > 0) {
          const _customSelectSingle =
            $(".custom-form").find(".js-custom-single");
          _customSelectSingle.each(function () {
            $(this).select2({
              placeholder:
                $(this).data("placeholder") &&
                $(this).data("placeholder").length
                  ? $(this).data("placeholder")
                  : "",
              allowClear: false,
              theme: "style-1",
              dropdownParent: $(this).parent(),
            });
          });
          const _customSelectSingle2 = $(
            ".custom-form.custom-form-without-label",
          ).find(".form-select");
          _customSelectSingle2.each(function () {
            $(this).select2({
              placeholder:
                $(this).data("placeholder") &&
                $(this).data("placeholder").length
                  ? $(this).data("placeholder")
                  : "",
              allowClear: false,
              theme: "style-2",
              dropdownParent: $(this).parent(),
            });
          });
          const _customSelectSingle3 = $(
            ".custom-form.custom-form-with-label",
          ).find(".form-select");
          _customSelectSingle3.each(function () {
            $(this).select2({
              placeholder:
                $(this).data("placeholder") &&
                $(this).data("placeholder").length
                  ? $(this).data("placeholder")
                  : "Choisir",
              allowClear: false,
              theme: "style-2",
              dropdownParent: $(this).parent(),
            });
          });
        }
      },
      customFormConstatCalcul: function () {
        const critairRules = {
          leger: {
            diesel: {
              2003: 4,
              2004: 4,
              2005: 4,
              2006: 3,
              2007: 3,
              2008: 3,
              2009: 3,
              2010: 3,
              2011: 2,
              2012: 2,
              2013: 2,
              2014: 2,
              2015: 2,
              2016: 2,
              2017: 2,
              2018: 2,
              2019: 2,
              2020: 2,
              2021: 2,
              2022: 2,
            },
            essence: {
              2003: 3,
              2004: 3,
              2005: 3,
              2006: 2,
              2007: 2,
              2008: 2,
              2009: 2,
              2010: 2,
              2011: 1,
              2012: 1,
              2013: 1,
              2014: 1,
              2015: 1,
              2016: 1,
              2017: 1,
              2018: 1,
              2019: 1,
              2020: 1,
              2021: 1,
              2022: 1,
            },
          },
          lourd: {
            diesel: {
              2003: 5,
              2004: 5,
              2005: 5,
              2006: 5,
              2007: 4,
              2008: 4,
              2009: 3,
              2010: 3,
              2011: 3,
              2012: 3,
              2013: 3,
              2014: 2,
              2015: 2,
              2016: 2,
              2017: 2,
              2018: 2,
              2019: 2,
              2020: 2,
              2021: 2,
              2022: 2,
            },
            essence: {
              2003: "N/A",
              2004: "N/A",
              2005: "N/A",
              2006: "N/A",
              2007: "N/A",
              2008: "N/A",
              2009: "N/A",
              2010: "N/A",
              2011: "N/A",
              2012: "N/A",
              2013: "N/A",
              2014: "N/A",
              2015: "N/A",
              2016: "N/A",
              2017: "N/A",
              2018: "N/A",
              2019: "N/A",
              2020: "N/A",
              2021: "N/A",
              2022: "N/A",
            },
          },
        };
        const zfeRules = {
          paris: {
            1: "Pas de restriction",
            2: "2024",
            3: "2022",
            4: "Non autorisé",
            5: "Non autorisé",
          },
          rouen: {
            1: "Pas de restriction",
            2: "Pas de restriction",
            3: "2023",
            4: "Non autorisé",
            5: "Non autorisé",
          },
          lyon: {
            1: "Pas de restriction",
            2: "Pas de restriction",
            3: "2024",
            4: "2023",
            5: "Non autorisé",
          },
          grenoble: {
            1: "Pas de restriction",
            2: "2025",
            3: "2022",
            4: "Non autorisé",
            5: "Non autorisé",
          },
          toulouse: {
            1: "Pas de restriction",
            2: "Pas de restriction",
            3: "2024",
            4: "2022",
            5: "Non autorisé",
          },
          autre: {
            1: "Pas de restriction",
            2: "Pas de restriction",
            3: "Pas de restriction",
            4: "Pas de restriction",
            5: "Pas de restriction",
          },
        };
        const idSelect = ["typevehicule", "annee", "carburant", "zfe"];

        $("body").on(
          "change",
          ".block-constat-form select.js-custom-single",
          function (e) {
            const id = $(this).attr("id");
            let paragraphId = id.split("-");
            paragraphId = paragraphId[paragraphId.length - 1];
            let formComplete = true;
            let formResponses = {};

            idSelect.forEach((selectId) => {
              formResponses[selectId] = $(
                "#" + selectId + "-" + paragraphId,
              ).val();
              if (!formResponses[selectId]) {
                formComplete = false;
                formResponses = {};
              }
            });

            if (formComplete) {
              if (
                critairRules.hasOwnProperty(formResponses["typevehicule"]) &&
                critairRules[formResponses["typevehicule"]].hasOwnProperty(
                  formResponses["carburant"],
                ) &&
                critairRules[formResponses["typevehicule"]][
                  formResponses["carburant"]
                ].hasOwnProperty(formResponses["annee"])
              ) {
                const critair =
                  critairRules[formResponses["typevehicule"]][
                    formResponses["carburant"]
                  ][formResponses["annee"]];

                if (
                  zfeRules.hasOwnProperty(formResponses["zfe"]) &&
                  zfeRules[formResponses["zfe"]].hasOwnProperty(critair)
                ) {
                  $(
                    ".custom-form .form-constat .custom-form-footer .result",
                  ).show();
                  if (zfeRules[formResponses["zfe"]][critair] !== "2024") {
                    $(".value-" + paragraphId).text(
                      zfeRules[formResponses["zfe"]][critair],
                    );
                    $(".exception").text("");
                  } else {
                    $(".value-" + paragraphId).text(
                      zfeRules[formResponses["zfe"]][critair] + "*",
                    );
                    $(".exception").text(
                      "*L’année indiquée est susceptible d’être modifiée.",
                    );
                  }
                }
              }
            }
          },
        );
      },
      burgerMenu: function () {
        if (app.isMobile) {
          const _body = $("body");
          const _btnBurgerMenu = $(".header .menu-icon");
          _btnBurgerMenu.on("click", function () {
            _body.toggleClass("menu-open");
          });
        }
      },
      flipCardsMobile: function () {
        if (app.isMobile) {
          if ($(".block-question-reponse")) {
            let _cards = $(".card-flip");
            _cards.each(function () {
              let _card = $(this);
              _card.on("click", function (e) {
                e.preventDefault();
                $(this).addClass("flip-mobile");
                if ($(this).hasClass("flip-mobile")) {
                  $(this).unbind(e);
                }
              });
            });
          }
        }
      },
      initDataLayerClick: function () {
        if ($(".block-list-vehicules").length > 0) {
          const _listVehicules = $(".block-list-vehicules .item-vehicule");
          _listVehicules.each(function () {
            const _vehicule = $(this);
            const _vehiculeName = _vehicule.attr("data-name");
            const _vehiculeId = _vehicule.attr("data-id");
            _link = _vehicule.find(".item-vehicule--cta");
            _link.on("click", function () {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push({
                event: "select_item",
                ecommerce: {
                  items: [
                    {
                      item_name: _vehiculeName,
                      item_id: _vehiculeId,
                      item_category: "Véhicule frigorifique",
                    },
                  ],
                },
              });
            });
          });
        }
      },
      initDataLayerSubmit: function () {
        if ($(".block-form-contact-v2").length > 0) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "generated_lead",
            form_label: "Contact Energies Nouvelles",
          });
        }
      },

      modalFeatures: function () {
        if ($("#modalInformationAuto").length > 0) {
          const popup = new Foundation.Reveal($("#modalInformationAuto"));
          setTimeout(function () {
            popup.open();
          }, 2500);
        }
      },
    };
    app.init();
  });
})(jQuery);
